var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSelectedProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.506,
    height: 42.109,
    viewBox: "0 0 66.506 42.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mina_resurser",
    "data-name": "Mina resurser",
    transform: "translate(-12176.482 -2117.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\xE4ckar",
    transform: "translate(12215.085 2125.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24324",
    "data-name": "Path 24324",
    d: "M-65.43,9.66l15.191-4.776,11.048,4.891-13.292,4.776Z",
    transform: "translate(65.931 -0.942)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24325",
    "data-name": "Path 24325",
    d: "M-65.43,12.585v17.55a1.6,1.6,0,0,0,.946,1.462l11.2,5.045a1.605,1.605,0,0,0,1.269.021l11.94-4.908a1.6,1.6,0,0,0,.994-1.493L-39.19,12.7",
    transform: "translate(65.931 -3.868)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1049",
    "data-name": "Line 1049",
    y1: 19.288,
    transform: "translate(13.447 13.611)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1050",
    "data-name": "Line 1050",
    y2: 8.861,
    transform: "translate(15.692 3.941)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24326",
    "data-name": "Path 24326",
    d: "M-24.869,9.875l-.574-3.047a.779.779,0,0,1,.765-.923h0a.779.779,0,0,1,.776.842l-.248,3.071",
    transform: "translate(50.747 -1.33)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24327",
    "data-name": "Path 24327",
    d: "M-41.943,2.5l-.574-3.047a.778.778,0,0,1,.765-.923h0a.779.779,0,0,1,.776.842l-.249,3.071",
    transform: "translate(57.232 1.472)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24328",
    "data-name": "Path 24328",
    d: "M-65.651,9.968l-.574-3.047A.779.779,0,0,1-65.459,6h0a.779.779,0,0,1,.776.842l-.249,3.072",
    transform: "translate(66.238 -1.365)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24329",
    "data-name": "Path 24329",
    d: "M-45.933,17.53l-.574-3.047a.778.778,0,0,1,.765-.923h0a.779.779,0,0,1,.776.842l-.249,3.071",
    transform: "translate(58.748 -4.238)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1051",
    "data-name": "Line 1051",
    x1: 4.057,
    y2: 1.352,
    transform: "translate(22.77 20.053)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1052",
    "data-name": "Line 1052",
    x1: 5.38,
    y2: 1.87,
    transform: "translate(21.418 22.47)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1053",
    "data-name": "Line 1053",
    x1: 6.991,
    y2: 2.474,
    transform: "translate(19.807 24.772)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(12177.434 2118.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M306.359,834.978v-3.21c0-9.331,6.986-16.9,15.6-16.9h3.655c8.617,0,15.6,2.626,15.6-8.335v-4.964",
    transform: "translate(-306.359 -799.315)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    transform: "translate(11.407)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 6.026,
    cy: 6.026,
    rx: 6.026,
    ry: 6.026,
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectedProducts);
export default __webpack_public_path__ + "static/media/Icon_selectedProducts.90ac3373880b23e1c264ca639cb7fc20.svg";
export { ForwardRef as ReactComponent };